import type { EventName } from "@lit/react";
import { TextArea as TextAreaElement, type TextAreaEventMap as _TextAreaEventMap, } from "@vaadin/text-area/vaadin-text-area.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { TextAreaElement, };
export type TextAreaEventMap = Readonly<{
    onValidated: EventName<_TextAreaEventMap["validated"]>;
    onChange: EventName<_TextAreaEventMap["change"]>;
    onInput: EventName<_TextAreaEventMap["input"]>;
    onInvalidChanged: EventName<_TextAreaEventMap["invalid-changed"]>;
    onValueChanged: EventName<_TextAreaEventMap["value-changed"]>;
}>;
const events = { onValidated: "validated", onChange: "change", onInput: "input", onInvalidChanged: "invalid-changed", onValueChanged: "value-changed" } as TextAreaEventMap;
export type TextAreaProps = WebComponentProps<TextAreaElement, TextAreaEventMap>;
export const TextArea = createComponent({
    elementClass: TextAreaElement, events, react: React, tagName: "vaadin-text-area"
});
